import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { MessagingModule } from '../../../../messaging/messaging.module';

@Component({
  selector: 'app-mailings-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    MessagingModule,
  ],
  templateUrl: './mailings-dashboard-page.component.html',
})
export class MailingsDashboardPageComponent { }
